/**
 * Deployment license for using AG Grid Enterprise in GIC Marketplace.
 *
 * Can only use ag-grid versions released before 14 December 2025
 *
 * | ag-grid version | release date | allowed to use |
 * | --------------- | ------------ | -------------- |
 * | 33.3.2          | 2025-06-04   | yes            |
 * | 34.0.2          | 2025-07-15   | yes            |
 *
 * @see {@link https://cwan.atlassian.net/wiki/spaces/CLIENTEXP/pages/129448835/ag-grid+license+tracking}
 */
export const AG_GRID_KEY: string =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-090923}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Clearwater_Analytics,_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{25}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{6}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_December_2025}____[v3]_[01]_MTc2NTY3MDQwMDAwMA==f490708039c82a63f0249f274897d141'
